import * as yup from 'yup';

export const tokenSchema = yup.object().shape({
  code: yup
    .string()
    .required('Informe o token.')
    .matches(/^[A-Za-z0-9]{6}$/, 'O token deve conter 6 dígitos.'),
});
